document.addEventListener("DOMContentLoaded", function () {
  const logoCarousel = document.querySelector(".logo-carousel__swiper");

  if (logoCarousel) {
    const swiper = new Swiper(".logo-carousel__swiper", {
      loop: true,
      // new
      freeMode: true,
      // new
      freeModeMomentum: true,
      spaceBetween: 136,
      // new
      gradCursor: true,
      slidesPerView: "auto",
      centeredSlides: true,
      effect: "slide",
      speed: 4000,
      autoplay: {
        delay: 1,
        disableOnInteraction: true,
      },
      breakpoints: {
        1400: {
          spaceBetween: 140,
        },
        992: {
          spaceBetween: 124,
        },
        640: {
          spaceBetween: 92,
        },
        320: {
          spaceBetween: 46,
        },
      },

      pagination: {
        el: ".swiper-pagination",
      },
    });
  }
});
